import { useOrderNote } from 'hooks/business/chat/useOrderNote';
import { DetailCard } from '../DetailCard';
import { useTranslate } from '@tolgee/react';
import { OrderNote } from '../OrderCard/OrderNote';
import { Button } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { OrderQueryParams } from 'hooks/business/chat/useOrderList';

interface CommentCardProps {
  order: Conversation.Trade.Vo;
  /** 用于乐观更新的查询参数 */
  queryParams?: OrderQueryParams;
}

export const CommentCard = (props: CommentCardProps) => {
  const { order, queryParams } = props;
  const { t } = useTranslate();
  const { enable, note, isShopeeIn30daysMemo } = useOrderNote(order);

  if (!enable) {
    return null;
  }

  return (
    <DetailCard
      title={t('trade.commentContent')}
      rightExtra={
        <OrderNote
          isShopeeIn30daysMemo={isShopeeIn30daysMemo}
          internalTradeId={order.internalTradeId}
          platform={order.platform}
          content={note}
          renderButton={(isEditState, onClick) => (
            <Button
              size="small"
              type="link"
              onClick={() => {
                console.log('onClick');
                onClick();
              }}
              icon={isEditState ? <EditOutlined /> : <PlusOutlined />}
            >
              {isEditState ? t('btn_modify') : t('添加')}
            </Button>
          )}
          queryParams={queryParams}
        />
      }
    >
      {note}
    </DetailCard>
  );
};
